<template>
  <div class="card series-archives-page">
    <div class="card-body">
      <div>
        <div class="page-header d-flex justify-content-between align-items-center mb-4">
          <h3 class="mb-0">
            Все серии
          </h3>
          <b-button
            variant="primary"
            @click="$bvModal.show('bv-modal-create-serie')"
          >
            <i class="fas fa-plus" />
            <span class="ml-1">Создать серию</span>
          </b-button>
        </div>

        <div
          v-if="!allSeries.length"
          class="text-muted mt-4"
        >
          Нет доступных серий
        </div>

        <div
          v-else
          class="row"
        >
          <div
            v-for="serie in allSeries"
            :key="serie.id"
            class="col-md-6 mb-4"
          >
            <div class="card h-100 shadow-sm border entity-card">
              <div class="card-header">
                <div class="entity-header-row mb-2 d-flex justify-content-between w-100 align-items-center">
                  <b-badge
                    variant="info"
                    class="mr-2"
                  >
                    Кол-во стартов: {{ serie.starts.length }}
                  </b-badge>
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeSerie(serie)"
                  >
                    <i class="fas fa-trash-alt" />
                    <span>Удалить серию</span>
                  </b-button>
                </div>
                <span>Название серии</span>
                <input
                  v-model="serie.name"
                  class="form-control form-control-sm"
                  placeholder="Название серии"
                  @blur="updateSerieName(serie)"
                >
              </div>

              <div class="card-body entity-body">
                <div class="mb-2 d-flex align-items-center">
                  <b-form-input
                    v-model="newStartId"
                    type="number"
                    placeholder="ID старта"
                    size="sm"
                    class="mr-2"
                    style="max-width: 120px;"
                    @keyup.enter="addStart(serie)"
                  />
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="addStart(serie)"
                  >
                    <i class="fas fa-plus" /> Добавить
                  </b-button>
                </div>

                <div
                  v-if="!serie.starts.length"
                  class="empty-state"
                >
                  Нет стартов в серии
                </div>

                <transition-group
                  v-else
                  name="fade"
                  tag="div"
                  class="row"
                >
                  <div
                    v-for="start in serie.starts"
                    :key="start.id"
                    class="col-md-6 mb-3 item-card"
                  >
                    <div class="card h-100 shadow-sm linked-item-card">
                      <div class="card-body text-center">
                        <h6 class="card-title mb-2">
                          {{ start.name || 'Без названия' }}
                        </h6>
                        <p class="card-text text-muted mb-2">
                          ID: {{ start.id }}
                        </p>
                        <b-button
                          size="sm"
                          variant="danger"
                          @click="removeStart(serie, start)"
                        >
                          <i class="fas fa-trash-alt" /> Удалить
                        </b-button>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DistanceModalCreateSerie
      modal-id="bv-modal-create-serie"
      @serie-created="fetchAllSeries"
    />
  </div>
</template>

<script>
import { BButton, BBadge, BFormInput } from 'bootstrap-vue'
import DistanceModalCreateSerie from './new-version/DistanceModalCreateSerie.vue'

export default {
  name: 'AllSeriesPage',
  components: { BButton, BBadge, BFormInput, DistanceModalCreateSerie },
  data() {
    return {
      allSeries: [],
      newStartId: '',
    }
  },
  mounted() {
    this.fetchAllSeries()
  },
  methods: {
    async addStart(serie) {
      const id = parseInt(this.newStartId, 10)
      if (!id || Number.isNaN(id)) {
        this.$bvToast.toast('Введите корректный ID старта', {
          title: 'Ошибка',
          variant: 'warning',
          solid: true,
        })
        return
      }

      const startIds = (serie.starts || []).map(s => s.id)
      if (startIds.includes(id)) {
        this.$bvToast.toast('Старт уже в серии', {
          title: 'Внимание',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        const payload = {
          startIds: [...startIds, id],
        }

        await this.$http.put('start/start-series/change-serie', payload, {
          params: { id: serie.id },
        })

        await this.fetchAllSeries()

        this.newStartId = ''

        this.$bvToast.toast('Старт добавлен в серию', {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Ошибка при добавлении старта', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },

    async fetchAllSeries() {
      try {
        const response = await this.$http.get('start/start-series/all-series')
        this.allSeries = response.data
      } catch (error) {
        console.error('Ошибка при загрузке серий:', error)
      }
    },

    async removeStart(serie, start) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Вы уверены, что хотите удалить старт «${start.name}» из серии "${serie.name}"?`,
        {
          title: 'Подтверждение удаления',
          okVariant: 'danger',
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          footerClass: 'p-2',
          centered: true,
        },
      )
      if (!confirmed) return

      try {
        const payload = {
          startIds: serie.starts.filter(s => s.id !== start.id).map(s => s.id),
        }

        await this.$http.put('start/start-series/change-serie', payload, {
          params: { id: serie.id },
        })

        // Локально обновляем UI
        serie.starts = serie.starts.filter(s => s.id !== start.id)

        this.$bvToast.toast(`Старт «${start.name}» удалён`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Ошибка при удалении старта', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },

    async updateSerieName(serie) {
      try {
        await this.$http.put('start/start-series/change-serie', {
          name: serie.name,
        }, {
          params: { id: serie.id },
        })
        this.$bvToast.toast('Название серии обновлено', {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Ошибка при обновлении названия', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },

    async removeSerie(serie) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Вы уверены, что хотите удалить серию "${serie.name}" со всеми стартами?`,
        {
          title: 'Подтверждение удаления',
          okVariant: 'danger',
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          footerClass: 'p-2',
          centered: true,
        },
      )
      if (!confirmed) return

      try {
        await this.$http.delete('start/start-series/remove-serie', {
          params: { id: serie.id },
        })

        // Локально удаляем серию
        this.allSeries = this.allSeries.filter(s => s.id !== serie.id)

        this.$bvToast.toast(`Серия "${serie.name}" удалена`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Ошибка при удалении серии', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import './scss/series-archives-shared.scss';
</style>
